module.exports = __webpack_public_path__ + "img/E-Bike_WM.79147b81.png";